export default "__VITE_ASSET__Bmbzh01A__"